import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=c9fe0cc6&"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts&"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports